import styled from "@emotion/styled";

export const Toolbar = styled.div<{
  $hasScrolled: boolean;
  $disableAnimation: boolean;
}>(({ $hasScrolled, $disableAnimation }) => ({
  position: "sticky" as const,
  background: $hasScrolled ? "white" : "transparent",
  top: 0,
  zIndex: 15,
  transition: $disableAnimation ? "unset" : "background 0.2s ease-in-out",
  ":before": {
    content: "''",
    display: "block",
    left: 0,
    right: 0,
    bottom: "-5px",
    position: "absolute",
    transition: $disableAnimation ? "unset" : "opacity 0.3s",
    height: "5px",
    zIndex: 2,

    opacity: $hasScrolled ? 0.15 : 0,
    background: "linear-gradient(-180deg, #000, transparent)",
  },
}));

export const ToolbarInner = styled.div(() => ({
  padding: 15,
  display: "flex",
  gap: "10px",
  overflow: "auto",
}));
